import {
	ArrowUpDown,
	BedDouble,
	Bike,
	BookOpen,
	Bus,
	Coffee,
	CookingPot,
	Dumbbell,
	Library,
	type LucideIcon,
	ParkingCircle,
	ShieldCheck,
	ShowerHead,
	Snowflake,
	Sofa,
	Sparkles,
	Trees,
	Utensils,
	Volleyball,
	WashingMachine,
	Wifi
} from 'lucide-react'

/**
 * The services a residence offers, as the closed list of the API. The icon and
 * the name of each are the same wherever they show: the admin ticks them, the
 * showcase lists them. An app indexes these records with the code type of its
 * own SDK, so a code the API adds without an icon here does not compile.
 */
export const SERVICE_ICON = {
	study_room: BookOpen,
	library: Library,
	common_kitchen: CookingPot,
	common_room: Sofa,
	laundry: WashingMachine,
	garden: Trees,
	wifi: Wifi,
	air_conditioning: Snowflake,
	bed_linen: BedDouble,
	cleaning: Sparkles,
	private_bathroom: ShowerHead,
	canteen: Utensils,
	vending: Coffee,
	security: ShieldCheck,
	gym: Dumbbell,
	sports_field: Volleyball,
	bike_parking: Bike,
	parking: ParkingCircle,
	shuttle: Bus,
	elevator: ArrowUpDown
} as const satisfies Record<string, LucideIcon>

export type ServiceCode = keyof typeof SERVICE_ICON

/** The services in the groups the apps show them in. */
export const SERVICE_GROUPS = [
	{ key: 'study', services: ['study_room', 'library'] },
	{
		key: 'common',
		services: ['common_kitchen', 'common_room', 'laundry', 'garden']
	},
	{
		key: 'comfort',
		services: [
			'wifi',
			'air_conditioning',
			'bed_linen',
			'cleaning',
			'private_bathroom'
		]
	},
	{ key: 'food_security', services: ['canteen', 'vending', 'security'] },
	{
		key: 'mobility',
		services: [
			'gym',
			'sports_field',
			'bike_parking',
			'parking',
			'shuttle',
			'elevator'
		]
	}
] as const satisfies readonly {
	key: string
	services: readonly ServiceCode[]
}[]

export type ServiceGroupKey = (typeof SERVICE_GROUPS)[number]['key']

/** Key of the name of a service in the `shared` translations. */
export const serviceLabelKey = (service: ServiceCode) =>
	`shared:residence_services.${service}` as const

/** Key of the name of a group of services in the `shared` translations. */
export const serviceGroupKey = (group: ServiceGroupKey) =>
	`shared:residence_service_groups.${group}` as const
